// extracted by mini-css-extract-plugin
export default {"component":"BattleArea_component__-B8OF","additionalButtonStyles":"BattleArea_additionalButtonStyles__8Ft59"};